module.exports = __webpack_public_path__ + "img/img1.cbc8aab2.jpg";